import { render } from "./vantage-bonus-088.vue?vue&type=template&id=65c002c1"
import script from "./vantage-bonus-088.js?vue&type=script&lang=js&external"
export * from "./vantage-bonus-088.js?vue&type=script&lang=js&external"

import "./vantage-bonus-088.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__